class AddEditLookupController {
    constructor(LookupsServiceApi, toastr) {
        this.ok = (lookup) => {
            // Save new or changed lookup group
            this.LookupService.saveLookup(lookup).then(() => {
                this.close();
            }, (response) => {
                let reason = response.data.Errors[0] || 'An error occurred.';
                this.toastr.error(reason, 'Validation Error');
            });
        };
        this.cancel = () => {
            // Cancel the page without any changes
            this.dismiss();
        };
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.lookup = this.resolve.lookup;
        };
        this.LookupService = LookupsServiceApi;
        this.toastr = toastr;
    }
}
angular.module('app').component('addEditLookupModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/LookupGroup/add-edit-lookup.tpl.html',
    controllerAs: 'vm',
    controller: AddEditLookupController
});
